import { render, staticRenderFns } from "./DetailedListTable.vue?vue&type=template&id=4d46a98c&scoped=true&"
import script from "./DetailedListTable.vue?vue&type=script&lang=js&"
export * from "./DetailedListTable.vue?vue&type=script&lang=js&"
import style0 from "./DetailedListTable.vue?vue&type=style&index=0&id=4d46a98c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d46a98c",
  null
  
)

export default component.exports